import debounce from 'lodash/debounce';
import { getScrollbarWidth } from '@/helpers/utils';

class CSSCustomProperties {
    constructor() {
        this.root = document.documentElement;
        this.nodeHeader = document.querySelector('[data-js-header]');

        this.headerObserver = new window.ResizeObserver(
            debounce(this.onLayoutChange.bind(this), 50)
        );

        this.mutationObserver = new window.MutationObserver(
            debounce(this.onLayoutChange.bind(this), 50)
        );

        this._boundOnScroll = this.onScroll.bind(this);
        this._boundOnResize = debounce(this.onWindowResize.bind(this), 100);

        this.alertHeight = 0;

		this.isFixed = false;
		this.fixedBuffer = 4; // pixels of tolerance
    }

    getAdminBarHeight() {
        const adminBar = document.getElementById('wpadminbar');
        if (!adminBar) return 0;
        return Math.round(adminBar.getBoundingClientRect().height);
    }

    updateHeights() {
        if (!this.nodeHeader) return;

        const headerHeight = Math.round(
            this.nodeHeader.getBoundingClientRect().height
        );

        const alert = this.nodeHeader.querySelector('[data-js-alert]');
        this.alertHeight = 0;

        if (alert && alert.classList.contains('alert--visible')) {
            this.alertHeight = Math.round(
                alert.getBoundingClientRect().height
            );
        }

        this.root.style.setProperty('--alert-height', `${this.alertHeight}px`);

        const adjustedHeaderHeight = headerHeight - this.alertHeight;

        this.root.style.setProperty(
            '--header-height',
            `${adjustedHeaderHeight}px`
        );

        const adminBarHeight = this.getAdminBarHeight();

        this.root.style.setProperty(
            '--admin-bar-height',
            `${adminBarHeight}px`
        );
    }	

    onScroll() {
        this.root.style.setProperty('--scroll-y', window.scrollY);
    }

    onWindowResize() {
        const scrollbarWidth = getScrollbarWidth();
        this.root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

        this.updateHeights();
    }

    onLayoutChange() {
        this.updateHeights();
    }

    bindUI() {
        window.addEventListener('resize', this._boundOnResize);
        window.addEventListener('scroll', this._boundOnScroll, { passive: true });

        if (this.nodeHeader) {
            this.headerObserver.observe(this.nodeHeader);

            this.mutationObserver.observe(this.nodeHeader, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['class']
            });
        }
    }

    init() {
        this.bindUI();
        this.onWindowResize();
        this.onLayoutChange();
        this.onScroll();
    }
}

export default function factory() {
    let module = new CSSCustomProperties();
    module.init();
    return module;
}
